import adminApi from '@/api/admin/adminClient';
import { ENDPOINTS } from '@/api/endpoints';
import type { ApiEnvelope } from '@/types/dashboard/auth';
import type { RateCard, RateCardPayload } from '@/types/dashboard/rate';

const url = ENDPOINTS.admin.kioskCrud.rateCharges;

export const rateService = {
  /** All rate cards, or only one vendor's when `vendorId` is given. */
  async list(vendorId?: number): Promise<RateCard[]> {
    const { data } = await adminApi.get<ApiEnvelope<RateCard[]>>(url, {
      params: vendorId ? { vendor: vendorId } : undefined,
    });
    return data.data;
  },

  async create(payload: RateCardPayload): Promise<RateCard> {
    const { data } = await adminApi.post<ApiEnvelope<RateCard>>(url, payload);
    return data.data;
  },

  /** PATCH: send only the fields that changed. */
  async update(id: number, payload: Partial<RateCardPayload>): Promise<RateCard> {
    const { data } = await adminApi.patch<ApiEnvelope<RateCard>>(`${url}${id}/`, payload);
    return data.data;
  },

  async remove(id: number): Promise<void> {
    await adminApi.delete(`${url}${id}/`);
  },
};
